import React from 'react';
import MediaQuery from 'react-responsive';

import { MAX_MOBILE_WIDTH, MIN_TABLET_WIDTH } from 'shared/constants';

import { Button } from 'shared/components/Button';

import 'shared/css/PublicSite.scss';

export interface ISignUpAndLogInButtons {
    onClickSignUp : () => void;
    onClickLogIn : () => void;
}

export class SignUpAndLogInButtons extends React.Component<ISignUpAndLogInButtons, object> {
    public render() {
        const {
            onClickSignUp,
            onClickLogIn,
        } = this.props;

        return (
            <ul className="sign-up-and-login-buttons">
                <li>
                    <a className="btn bevspot-button bs-psb bs-register button-modal button-default button-secondary" data-target="#modal-schedule-call">
                        <span className="bevicon bevico-headset">&nbsp;</span>
                        <MediaQuery maxWidth={ MAX_MOBILE_WIDTH }>
                            Chat
                        </MediaQuery>
                        <MediaQuery minWidth={ MIN_TABLET_WIDTH }>
                            Schedule a Chat
                        </MediaQuery>
                    </a>
                </li>
                <li>
                    <Button
                        buttonClassName="bs-psb bs-register"
                        isDisabled={ false }
                        isLoading={ false }
                        onClick={ onClickSignUp }
                    >
                        <MediaQuery maxWidth={ MAX_MOBILE_WIDTH }>
                            Free Trial
                        </MediaQuery>
                        <MediaQuery minWidth={ MIN_TABLET_WIDTH }>
                            Start Free Trial
                        </MediaQuery>
                    </Button>
                </li>
                <li>
                    <Button
                        buttonClassName="bs-psb bs-login"
                        isDisabled={ false }
                        isLoading={ false }
                        onClick={ onClickLogIn }
                    >
                        Log In
                    </Button>
                </li>
            </ul>
        );
    }
}
